module.exports = __webpack_public_path__ + "img/partner2.4fc5ec38.jpg";